export const messages = {
  en: {
    printerMachineLog: {
      queryCondition: 'Query Conditions',
      selectMachineCode: 'Please select device code',
      query: 'Query',
      printLog: 'Print Log',
      id: 'ID',
      machineCode: 'Device Code',
      shop: 'Shop',
      requestMessage: 'Request Message',
      responseMessage: 'Response Message',
      requestTime: 'Request Time'
    }
  },
  zh: {
    printerMachineLog: {
      queryCondition: '查询条件',
      selectMachineCode: '请选择设备编号',
      query: '查询',
      printLog: '打印日志',
      id: '编号',
      machineCode: '设备编号',
      shop: '商铺',
      requestMessage: '请求报文',
      responseMessage: '返回报文',
      requestTime: '请求时间'
    }
  }
}